import Card from 'components/Card/Card'
import styles from './CardList.module.css'
import {
  BlockTracking,
  Program,
  ProgramV2,
  RelatedProgram,
  RelatedSeries,
  Series,
  SeriesV2,
  Trailer,
} from 'frontend/types'
import { blockItemClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import React from 'react'
import { EdithCardLayout } from 'backend/services/types/edithService.types'
import { useRouter } from 'next/router'

interface Props {
  programs?:
    | (Series | Program)[]
    | (SeriesV2 | ProgramV2)[]
    | (RelatedProgram | RelatedSeries)[]
    | Trailer[]
  blockTracking?: BlockTracking
  testId?: string
  currentUrAssetId?: number
  isProgramOrSeriesPage?: boolean
  children?: React.ReactNode
  cardLayout: EdithCardLayout
  renderUpcomingCardsFirst?: boolean
  headingLevel: 2 | 3 | 4
  hideCardMetaData?: boolean
}

const CardList = ({
  programs = [],
  blockTracking,
  testId,
  currentUrAssetId,
  isProgramOrSeriesPage,
  children,
  cardLayout,
  headingLevel,
  renderUpcomingCardsFirst,
  hideCardMetaData,
}: Props) => {
  const router = useRouter()

  const childPageRegex = /^\/barn/

  const isOnChildPage = childPageRegex.test(router.asPath)
  return (
    <div
      className={styles.programsWrapper}
      {...(testId && { 'data-testid': testId })}
    >
      {renderUpcomingCardsFirst && children}
      {programs.map((program, index) => (
        <Card
          cardLayout={cardLayout}
          className={styles.card}
          key={program.id}
          product={program}
          currentUrAssetId={currentUrAssetId}
          onClick={() => {
            if (blockTracking) {
              blockItemClick({
                blockTracking: blockTracking,
                itemIndex: index + 1,
                product: program,
              })
            }
          }}
        >
          <Card.Image
            isOnChildPage={isOnChildPage}
            product={program}
            currentUrAssetId={currentUrAssetId}
            cardLayout={cardLayout}
          />
          <Card.Metadata
            headingLevel={headingLevel}
            cardLayout={cardLayout}
            product={program}
            productType={program.productType}
            isProgramOrSeriesPage={isProgramOrSeriesPage}
            currentUrAssetId={currentUrAssetId}
            hideCardMetaData={isOnChildPage || hideCardMetaData}
          />
        </Card>
      ))}
      {!renderUpcomingCardsFirst && children}
    </div>
  )
}

export default CardList
